import { render, staticRenderFns } from "./backup-edit.vue?vue&type=template&id=7979adea&scoped=true&"
import script from "./backup-edit.vue?vue&type=script&lang=js&"
export * from "./backup-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7979adea",
  null
  
)

export default component.exports